import * as React from 'react';
import {useEffect, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from 'store';
import {OptionValue} from 'model/form';
import {SelectFormField} from 'components/form/SelectFormField';
import {fetchCompetences} from 'store/competence';
import {selectCompetences} from 'store/selectors';

/**
 * Picks content competences. Unlike the user and content pickers the codebook is
 * small and static, so it is fetched once into the store and filtered client side.
 */
export const CompetenceSelectFormField = ({name, label, placeholder, isMulti, shrink}: {
    name: string,
    label: string,
    placeholder?: string,
    isMulti?: boolean,
    shrink?: boolean,
}) => {
    const dispatch = useAppDispatch();

    const {items, isLoading} = useSelector(selectCompetences);

    useEffect(() => {
        dispatch(fetchCompetences());
    }, [dispatch]);

    const options: OptionValue[] = useMemo(() =>
        items.map(c => ({value: c.id, label: c.name, tooltip: c.competence_type})), [items]);

    return <SelectFormField name={name} label={label} placeholder={placeholder} isMulti={isMulti}
        options={options} shrink={shrink} isLoading={isLoading}/>;
};
